import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useConfiguration } from '@travel-frontend/core';
import { useTranslation } from 'next-i18next';
import { Container } from '../../../../components/Footer/components/Links/components/Container.js';
import { Content } from '../../../../components/Footer/components/Links/components/Content.js';
import { Group } from '../../../../components/Footer/components/Links/components/Group/index.js';
import { Link } from '../../../../components/Footer/components/Links/components/Link/index.js';
import { TrustElement } from '../../../../components/Footer/components/TrustElement/TrustElement.js';
import { useGenerateLink } from '../../../../components/hooks/useGenerateLink.js';
export const Links = ({
  links,
  path = '',
  showTrustElement,
  brandName
}) => {
  const {
    t
  } = useTranslation(['footer']);
  const {
    generateLink
  } = useGenerateLink();
  const domain = useConfiguration('domain');
  return _jsxs(Container, {
    spacing: 4,
    children: [_jsx(Content, {
      children: links.map(({
        headline = '',
        items,
        id
      }, index) => _jsx(Group, {
        title: t(headline),
        id: id,
        children: items.map(({
          label,
          url,
          masked,
          addCurrentPath,
          target
        }) => _jsx(Link, {
          target: target,
          href: generateLink(url || '', path, addCurrentPath),
          masked: masked,
          children: t(label, {
            brandName,
            domain
          })
        }, `${label}-${url}`))
      }, index))
    }), showTrustElement && _jsx(TrustElement, {})]
  });
};